shouldWrite